"use client";
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { Html } from "@custom/schema";
import { Dialog, Transition } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/outline";
import clsx from "clsx";
import { motion } from "framer-motion";
import React, { Fragment, useState } from "react";
import ArrowLink from "../molecules/ArrowLink";
export default function CtaSlider(props) {
    var _useState = _sliced_to_array(useState(0), 2), currentSlide = _useState[0], setCurrentSlide = _useState[1];
    var sliderContainsQuotes = props.ctaSlide.some(function(slide) {
        return slide === null || slide === void 0 ? void 0 : slide.isQuote;
    });
    var sliderContainsCtas = props.ctaSlide.some(function(slide) {
        return slide === null || slide === void 0 ? void 0 : slide.cta;
    });
    var ctaSlide = props.ctaSlide;
    var _useState1 = _sliced_to_array(useState(null), 2), openModalIndex = _useState1[0], setOpenModalIndex = _useState1[1];
    var closeModal = function() {
        setOpenModalIndex(null);
    };
    var openModal = function(index) {
        setOpenModalIndex(index);
    };
    return /*#__PURE__*/ React.createElement("div", {
        className: clsx("px-6 md:px-14 relative z-[11] mb-16 lg:mb-0 pb-14 md:pb-0", {
            "lg:pb-44": sliderContainsQuotes === true
        })
    }, /*#__PURE__*/ React.createElement("div", {
        className: clsx("max-w-7xl mx-auto", {
            "lg:relative lg:z-[12]": sliderContainsQuotes === true
        })
    }, /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-col md:flex-row md:gap-x-8 items-center"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "w-full md:w-1/2 xl:w-5/12 max-[767px]:order-last"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "relative"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "overflow-hidden rounded-l-3xl"
    }, /*#__PURE__*/ React.createElement(motion.div, {
        animate: {
            x: "-".concat(currentSlide * 100, "%")
        },
        className: "flex",
        transition: {
            duration: 0.5
        }
    }, props.ctaSlide.map(function(slide, index) {
        var _slide_cta;
        /*#__PURE__*/ return React.createElement("div", {
            key: index,
            className: "flex-1 min-w-full flex items-stretch relative"
        }, /*#__PURE__*/ React.createElement("div", {
            className: "aspect-w-5 aspect-h-6 w-full"
        }, /*#__PURE__*/ React.createElement("img", {
            src: slide === null || slide === void 0 ? void 0 : slide.image,
            alt: "Slide ".concat(currentSlide + 1),
            className: "object-cover w-full"
        })), slide.cta && slide.cta.target && slide.cta.label ? /*#__PURE__*/ React.createElement("div", {
            className: "w-[180px] absolute bottom-4 max-[767px]:inset-x-0 md:right-2 max-[767px]:mx-auto"
        }, /*#__PURE__*/ React.createElement("div", {
            className: "absolute bottom-6 z-20 md:bottom-8 w-full inset-x-0 text-center md:text-right md:left-[unset] md:right-9"
        }, /*#__PURE__*/ React.createElement("button", {
            onClick: function() {
                return openModal(index);
            },
            className: "button-primary py-2.5 px-5 w-auto inline-flex items-center justify-center border-gray-600 bg-white text-gray-600 hover:bg-gray-600 hover:text-white"
        }, /*#__PURE__*/ React.createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "18px",
            height: "18px",
            viewBox: "0 0 18 18",
            version: "1.1",
            className: "mr-2.5 shrink-0 relative -top-px"
        }, /*#__PURE__*/ React.createElement("title", null, "Icon/Play/Black"), /*#__PURE__*/ React.createElement("g", {
            id: "Symbols",
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd"
        }, /*#__PURE__*/ React.createElement("g", {
            id: "Button/Watch/White/Icon/Static",
            transform: "translate(-19.000000, -13.000000)"
        }, /*#__PURE__*/ React.createElement("g", {
            id: "Icon/Play/Black",
            transform: "translate(19.000000, 13.000000)"
        }, /*#__PURE__*/ React.createElement("path", {
            d: "M17.5,0.5 L17.5,17.5 L0.5,17.5 L0.5,0.5 L17.5,0.5 Z",
            id: "Path",
            stroke: "currentColor"
        }), /*#__PURE__*/ React.createElement("polygon", {
            id: "Path",
            fill: "currentColor",
            points: "6 5.11694 12.4718 9 6 12.8831"
        }))))), slide.cta.label), /*#__PURE__*/ React.createElement(Transition, {
            appear: true,
            show: openModalIndex === index,
            as: Fragment
        }, /*#__PURE__*/ React.createElement(Dialog, {
            as: "div",
            className: "relative z-[26]",
            onClose: closeModal,
            "aria-label": "Slider modal"
        }, /*#__PURE__*/ React.createElement(Transition.Child, {
            as: Fragment,
            enter: "ease-out duration-300",
            enterFrom: "opacity-0",
            enterTo: "opacity-100",
            leave: "ease-in duration-200",
            leaveFrom: "opacity-100",
            leaveTo: "opacity-0"
        }, /*#__PURE__*/ React.createElement("div", {
            className: "fixed inset-0 bg-black bg-opacity-75"
        })), /*#__PURE__*/ React.createElement("div", {
            className: "fixed inset-0 overflow-y-auto"
        }, /*#__PURE__*/ React.createElement("div", {
            className: "flex min-h-full items-center justify-center p-4 text-center"
        }, /*#__PURE__*/ React.createElement(Transition.Child, {
            as: Fragment,
            enter: "ease-out duration-300",
            enterFrom: "opacity-0 scale-95",
            enterTo: "opacity-100 scale-100",
            leave: "ease-in duration-200",
            leaveFrom: "opacity-100 scale-100",
            leaveTo: "opacity-0 scale-95"
        }, /*#__PURE__*/ React.createElement(Dialog.Panel, {
            className: "w-full max-w-3xl relative text-left align-middle transition-all"
        }, /*#__PURE__*/ React.createElement("div", {
            className: "mt-2"
        }, /*#__PURE__*/ React.createElement("iframe", {
            width: "717",
            height: "403",
            src: "".concat(slide === null || slide === void 0 ? void 0 : (_slide_cta = slide.cta) === null || _slide_cta === void 0 ? void 0 : _slide_cta.target, "?autoplay=1"),
            title: "Wistia video player",
            allow: "autoplay; encrypted-media",
            allowFullScreen: true,
            className: "max-w-full"
        })), /*#__PURE__*/ React.createElement("div", {
            className: "mt-4"
        }, /*#__PURE__*/ React.createElement("button", {
            type: "button",
            onClick: closeModal,
            className: "text-white absolute -top-10 md:-top-8 right-0 md:-right-4",
            "aria-label": "Close slider modal"
        }, /*#__PURE__*/ React.createElement(XMarkIcon, {
            className: "w-8 h-8"
        }))))))))))) : null);
    }))), props.ctaSlide.length > 1 ? /*#__PURE__*/ React.createElement("div", {
        className: clsx("flex md:hidden lg:flex absolute -bottom-8 lg:bottom-16 md:px-10 max-[767px]:w-full", {
            "lg:w-full": !sliderContainsCtas,
            "lg:w-[calc(100%-210px)]": sliderContainsCtas
        })
    }, /*#__PURE__*/ React.createElement("div", {
        className: "inset-x-0 flex gap-x-3.5 w-full"
    }, ctaSlide.map(function(_, index) {
        return /*#__PURE__*/ React.createElement("button", {
            className: "bg-gray-300 rounded flex-1 h-1 ".concat(index === currentSlide ? "bg-gray-600 md:bg-white" : ""),
            key: index,
            onClick: function() {
                return setCurrentSlide(index);
            }
        });
    }))) : null)), /*#__PURE__*/ React.createElement("div", {
        className: "md:w-1/2 xl:w-7/12 xl:max-w-2xl text-center md:text-left py-9 md:py-0 md:relative"
    }, props.ctaSlide.map(function(slide, index) {
        /*#__PURE__*/ return React.createElement(motion.div, {
            key: index,
            style: {
                display: currentSlide === index ? "block" : "none"
            },
            initial: {
                opacity: 0
            },
            animate: {
                opacity: 1
            },
            exit: {
                opacity: 0
            },
            transition: {
                duration: 0.5
            },
            className: clsx("", {
                "text-left": (slide === null || slide === void 0 ? void 0 : slide.isQuote) === true
            })
        }, (slide === null || slide === void 0 ? void 0 : slide.isQuote) === true ? /*#__PURE__*/ React.createElement("img", {
            src: "/images/slide-icon.svg",
            alt: "Quote icon",
            width: "80",
            className: "mb-6 md:mb-7 max-[767px]:w-10"
        }) : /*#__PURE__*/ React.createElement("span", {
            className: "pre-headline"
        }, slide === null || slide === void 0 ? void 0 : slide.label), (slide === null || slide === void 0 ? void 0 : slide.heading) ? /*#__PURE__*/ React.createElement("h3", {
            className: "text-2xl md:text-3xl lg:text-4xl my-2 md:mb-3"
        }, slide === null || slide === void 0 ? void 0 : slide.heading) : null, (slide === null || slide === void 0 ? void 0 : slide.text) ? /*#__PURE__*/ React.createElement("div", {
            className: clsx("", {
                "text-gray-600 md:text-xl lg:text-2xl md:leading-normal font-medium font-heading": (slide === null || slide === void 0 ? void 0 : slide.isQuote) === true,
                "md:text-xl text-gray-900": !(slide === null || slide === void 0 ? void 0 : slide.isQuote)
            })
        }, /*#__PURE__*/ React.createElement(Html, {
            markup: slide.text
        })) : null, (slide === null || slide === void 0 ? void 0 : slide.subtext) ? /*#__PURE__*/ React.createElement("div", {
            className: "text-gray-200 text-xs mt-2.5 md:mt-5"
        }, slide === null || slide === void 0 ? void 0 : slide.subtext) : null, slide.link && slide.link.target && slide.link.label ? /*#__PURE__*/ React.createElement(ArrowLink, {
            text: slide === null || slide === void 0 ? void 0 : slide.link.label,
            target: slide === null || slide === void 0 ? void 0 : slide.link.target,
            className: "mt-6"
        }) : null);
    }), props.ctaSlide.length > 1 ? /*#__PURE__*/ React.createElement("div", {
        className: "flex md:inline-flex max-[767px]:justify-between px-6 md:px-0 gap-x-6 mt-9 absolute -bottom-8 inset-x-0 md:static"
    }, /*#__PURE__*/ React.createElement("button", {
        className: 'disabled:opacity-30 disabled:cursor-not-allowed focus focus-visible:outline-black border border-black transition-all hover:bg-white p-1.5 bg-arrow text-[0px] after:content-[""] after:block after:h-4 after:w-4 after:rotate-180',
        onClick: function() {
            return setCurrentSlide(currentSlide - 1);
        },
        disabled: currentSlide === 0
    }, "Previous"), /*#__PURE__*/ React.createElement("button", {
        className: 'disabled:opacity-30 disabled:cursor-not-allowed focus focus-visible:outline-black border border-black transition-all hover:bg-white p-1.5 bg-arrow text-[0px] after:content-[""] after:block after:h-4 after:w-4',
        onClick: function() {
            return setCurrentSlide(currentSlide + 1);
        },
        disabled: currentSlide === ctaSlide.length - 1
    }, "Next")) : null))), sliderContainsQuotes === true ? /*#__PURE__*/ React.createElement("div", {
        className: "max-w-7xl mx-auto relative knime-hidden lg:block"
    }, /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1066px",
        height: "459px",
        viewBox: "0 0 1066 459",
        version: "1.1",
        className: "absolute -bottom-40 left-80"
    }, /*#__PURE__*/ React.createElement("title", null, "Blue Angle Line"), /*#__PURE__*/ React.createElement("g", {
        id: "Desktop",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Solutions-Page:-Financial-Analytics:-Desktop",
        transform: "translate(-374.000000, -2207.000000)",
        stroke: "#9CD0DE",
        strokeWidth: "2"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Page/Video-Resources",
        transform: "translate(75.000000, 1897.000000)"
    }, /*#__PURE__*/ React.createElement("polyline", {
        id: "Blue-Angle-Line",
        transform: "translate(832.500000, 539.000000) scale(1, -1) rotate(-360.000000) translate(-832.500000, -539.000000) ",
        points: "300 768 300 395.053166 410.08419 310 1365 310"
    })))))) : null);
}
